import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ags-signout-dialog',
  templateUrl: './signout-dialog.component.html',
  styleUrls: ['./signout-dialog.component.scss']
})
export class SignoutDialogComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  public dialogOpened: boolean = void 0;
  public dialogErrorMessage: string = void 0;
  public loadingRequest: boolean = void 0;
  public themingClassName: string = void 0;

  @Input('dialogOpened')
  set _dialogOpened(value: boolean) {
    this.dialogOpened = value;
  }

  @Input('loadingRequest')
  set _loadingRequest(value: boolean) {
    this.loadingRequest = value;
  }

  @Input('dialogErrorMessage')
  set _dialogErrorMessage(value: string) {
    this.dialogErrorMessage = value;
  }

  @Input('themingClassName')
  set _themingClassName(value: string) {
    this.themingClassName = value;
  }

  @Output() closeDialog = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.themingClassName}`;
  }

  close() {
    if (!this.loadingRequest) {
      this.closeDialog.emit(false);
    }
  }

  action(choice = 'no') {
    switch (choice) {
      case 'no':
        this.closeDialog.emit(false);
        break;
      case 'yes':
        this.closeDialog.emit(true);
        break;
      default:
    }
  }
}
